import { render, staticRenderFns } from "./DataValidationModal.vue?vue&type=template&id=170b3eae&scoped=true&"
import script from "./DataValidationModal.vue?vue&type=script&lang=ts&"
export * from "./DataValidationModal.vue?vue&type=script&lang=ts&"
import style0 from "./DataValidationModal.vue?vue&type=style&index=0&id=170b3eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170b3eae",
  null
  
)

export default component.exports